import React, { useEffect } from 'react';
import { PayPalButtons, SCRIPT_LOADING_STATE, DISPATCH_ACTION, usePayPalScriptReducer } from '@paypal/react-paypal-js';
import service from '../../../services/service';
import { getLocaleStorageItem } from '../../../utils/localStorageHelper';
import { draftId } from '../../../constants/payData';

interface IProps {
  price: number;
  createOrder: any;
  isDisabled?: boolean;
  onClickFn?: any;
  styles?: { [key: string]: string | number | boolean }; // { color?: "black" | "white" | "gold" | "blue" | "silver"; disableMaxWidth?: boolean; height?: number; label?: "paypal" | "checkout" | "buynow" | "pay" | "installment" | "subscribe" | "donate"; layout?: "vertical" | "horizontal"; shape?: "rect" | "pill"; tagline?: boolean; }
}

const PayPalComponent = (props: IProps) => {
  const { price, createOrder, onClickFn, isDisabled = false, styles = { height: 35 } } = props;
  const [{ isInitial }, dispatch] = usePayPalScriptReducer();
  const draft = getLocaleStorageItem(draftId);

  useEffect(() => {
    if (isInitial) {
      dispatch({ type: DISPATCH_ACTION.LOADING_STATUS, value: SCRIPT_LOADING_STATE.PENDING });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitial]);

  return (
    <div className={`paypal-wrapper ${isDisabled ? 'pay-pal-disabled' : ''}`} data-disabled={isDisabled}>
      <PayPalButtons
        style={styles}
        className="paypal-card"
        onClick={onClickFn}
        createOrder={() => {
          const totalPrice = Number(price).toFixed(2);
          return service.paypalPayment(+totalPrice, draft ? +draft : null).then((value) => value.data.id);
        }}
        fundingSource={'paypal'}
        onApprove={async (data) => {
          await service.paypalCapture(data.orderID).then(() => createOrder());
        }}
      />
    </div>
  );
};

export default PayPalComponent;
